import {AfterViewInit, Component, ViewEncapsulation} from '@angular/core';
import { AuthService } from '../../shared/services/auth/auth.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class MainLayoutComponent implements AfterViewInit {
  constructor(public readonly authService: AuthService) {
  }

  ngAfterViewInit(): void {
    //theme js function lazyload after component
    (window as any).W3Crm.init(); 

  }
}
